/**
 * iter358 — warm the in-app route chunks after boot.
 *
 * Screens are code-split, so one the user has not opened yet lives in a chunk
 * that was never downloaded. Offline, that request failed and React.lazy
 * rendered a white screen — "open Personal with no signal" was broken even
 * though all of its data was already on the device.
 *
 * Fetching the modules while the connection is still up means webpack already
 * holds them (and the service worker has cached the hashed files), so the
 * screens open offline. Runs once, idle-scheduled, so it never competes with
 * the first paint.
 */
let warmed = false;

export function warmAppChunks(): void {
  if (warmed) return;
  warmed = true;

  const loaders: Array<() => Promise<unknown>> = [
    () => import('../components/GymNotebook'),
    () => import('../components/PersonalSettingsPanel'),
    () => import('../components/RecoveryPage'),
    () => import('../components/NutritionTracker'),
    () => import('../components/WalkingSetup'),
    () => import('../components/WalkingTimer'),
    () => import('../components/TrainingInProgress'),
    () => import('../components/TrainingPlanner'),
    () => import('../components/WorkoutCalendar'),
    () => import('../components/WorkoutStatistics'),
    () => import('../components/HistoryScreen'),
    () => import('../components/DataManagement'),
  ];

  const run = () => {
    // Sequential: a burst of parallel chunk requests on a phone competes with
    // the data the visible screen is still loading.
    loaders.reduce<Promise<unknown>>(
      (chain, load) => chain.then(() => load().catch(() => undefined)),
      Promise.resolve(),
    );
  };

  const w = window as any;
  if (typeof w.requestIdleCallback === 'function') w.requestIdleCallback(run, { timeout: 8000 });
  else setTimeout(run, 4000);
}
